import { render, staticRenderFns } from "./SupplierRequest.vue?vue&type=template&id=b85499a4&scoped=true&"
import script from "./SupplierRequest.vue?vue&type=script&lang=js&"
export * from "./SupplierRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85499a4",
  null
  
)

export default component.exports